import type { JsonValue } from './common.types';

export type {
    CustomerDetails,
    GetReceiptDataResponse,
    GenericIpwTransactionDetails,
    ProcessAchPaymentRequest,
    ProcessAchPaymentResponse,
    ProcessCardTokenPaymentRequest,
    ProcessCardTokenPaymentResponse,
    ProcessCardNotPresentPaymentResponse,
    RecordTokenRequest,
    RecordTokenResponse,
    TerminalAbortRequest,
    TerminalAbortResponse,
    TerminalSaleRequest,
    TerminalSaleResponse,
    TransactionDetails,
    TransactionDetailsCreateRequest,
    GatewayCardTokenizationResponse,
} from './payment.types';

export type { ProcessCloverCardNotPresentPaymentRequest } from './types/ipg/clover/clover-card-not-present-payment.types';

export interface SambaGatewayTransactionDetailsFetchResult {
    readonly gateway_transaction_details: JsonValue;
    readonly gateway_response: JsonValue;
    readonly gateway_response_type: string;
    readonly gateway_response_status: number;
    readonly gateway_response_header: Record<string, string>;
    readonly gateway_endpoint_url?: string;
}

export const CardType = {
    DEBIT: 'DEBIT',
    CREDIT: 'CREDIT',
    PREPAID: 'PREPAID',
    UNKNOWN: 'UNKNOWN',
} as const;

export type CardType = (typeof CardType)[keyof typeof CardType];
